import tw, { styled } from 'twin.macro'
import CloseIcon from '@components/Icons/CloseIcon'
import { useAutosaveLabel } from '../header/AutosaveIndicator'
import { useArticleContext } from '../_core'

const Header = styled.div`
  padding: 8px 16px;
  display: grid;
  grid-template:
    'close top finish'
    'close bottom finish' / auto 1fr auto;
  justify-items: center;
  align-items: center;
`

const Close = styled(CloseIcon)`
  grid-area: close;
`

const Finish = styled.div`
  grid-area: finish;
  font-weight: 500;
  ${tw`text-primary-indigo`};
`

const Title = styled.div`
  grid-area: top / close / top / finish;
  font-weight: 500;
  line-height: 1.35;
  ${tw`text-gray-800`};
`

const State = styled.div`
  grid-area: bottom / close / bottom / finish;
  font-size: 12px;
  line-height: 1.3;
  letter-spacing: 0.4px;

  ${tw`text-gray-400`};
`

type Props = {
  close: () => void
  title: string
}

const AutosaveStatusHeader = (props: Props) => {
  const { title, close } = props
  const {
    articleState: { autosaveStatus },
  } = useArticleContext()
  const autosaveLabel = useAutosaveLabel(autosaveStatus)

  return (
    <Header>
      <Close width="20" height="20" onClick={close} />
      <Title>{title}</Title>
      <State>{autosaveLabel}</State>
      <Finish onClick={close}>完成</Finish>
    </Header>
  )
}

export default AutosaveStatusHeader
